import React from "react";
import { Route } from "react-router-dom";
import { getSummonerProfileContext } from "components/SummonerProfiles/SummonerProfileContext";
import MediaQuery from "components/MediaQuery";
import { validParamsProfile } from "query_parameters/valid_parameters_profile";
import ProfileFilterManager from "components/SummonerProfiles/views/ProfilesMain/ProfileFilterManager";

const SummonerProfileFiltersContainer = (props) => {
  const context = getSummonerProfileContext();
  const { page } = context;

  const validPageParams = validParamsProfile[page] || {};
  let options = { ...validPageParams };
  return (
    <Route
      path={[
        // "/lol/profile/:region/:summonerName/overview",
        // "/lol/profile/:region/:summonerName/match-history",
        "/lol/profile/:region/:summonerName/champion-stats",
      ]}
      render={(routerProps) => (
        <React.Fragment>
          <MediaQuery min="MOBILE_SMALL" max="MOBILE_LARGE">
            <ProfileFilterManager page={page} options={options} isMobile />
          </MediaQuery>
          <MediaQuery min="TABLET" max="DESKTOP_LARGE">
            <ProfileFilterManager page={page} options={options} />
          </MediaQuery>
        </React.Fragment>
      )}
    />
  );
};

export default SummonerProfileFiltersContainer;
